module.exports = __webpack_public_path__ + "img/img43.2c89f041.svg";